<template>
  <div class="form-field" :class="{ required }">

    <ValidationProvider :key="name" :name="name" v-slot="{ errors }" persist :rules="rules">

      <div class="form-group">

        <label v-if="label" class="form-field-label"
               :for="name"
               :class="{'validation-error': errors.length > 0 }"
        >
          {{ label }}
        </label>
        <textarea class="form-control"
                  :class="{'validation-error': errors.length > 0 }"
                  :name="name"
                  v-bind:value="value"
                  @input="$emit('input', $event.target.value)"
                  :placeholder="placeholder"
        />

        <p v-if="errors[0]" class="validation-error">{{ errors[0] }}</p>

      </div>

    </ValidationProvider>

  </div>
</template>

<script>
import {ValidationProvider} from "vee-validate"

export default {
  name: "TextInput",
  props: ["name", "value", "label", "type", "placeholder", "rules", "required"],
  components: {
    ValidationProvider
  }
}
</script>

<style lang="scss" scoped>
.required {

  .form-field-label:after {
    content: '*';
    color: red;
  }
}
</style>
